import { render, staticRenderFns } from "./CommonReceptionDetailEditor.vue?vue&type=template&id=6f120287&scoped=true&"
import script from "./CommonReceptionDetailEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonReceptionDetailEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonReceptionDetailEditor.vue?vue&type=style&index=0&id=6f120287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f120287",
  null
  
)

export default component.exports